

export const BaseUrl = 'https://admin.foodweb-ibis.ksoftpl.com/api';
export const AssetsUrl = 'https://admin.foodweb-ibis.ksoftpl.com'; 

global.BaseUrl = 'https://admin.foodweb-ibis.ksoftpl.com/api';
global.AssetsUrl = 'https://admin.foodweb-ibis.ksoftpl.com';


